<script lang="ts">
	import { GameCategory as CatalogGameCategory } from '@infinitro/catalog-min';
	import { GameCategory as GameCategoryLobby } from '@infinitro/game-category';
	import { SeoText } from '@infinitro/seo-text';
	import type { GameCategory } from '$lib/category';

	type SeoSection =
		| 'slots'
		| 'live-casino'
		| 'game-shows'
		| 'new-games'
		| 'popular-games'
		| 'feature-buy-in'
		| 'home';

	const categoryToSection: Partial<Record<GameCategory, SeoSection>> = {
		slots: 'slots',
		livecasino: 'live-casino',
		gameshows: 'game-shows',
		newgames: 'new-games',
		populargames: 'popular-games',
		featurebuyin: 'feature-buy-in'
	};

	export let data: { category: GameCategory };

	$: gameCategory = data.category as unknown as CatalogGameCategory;
	$: seoSection = categoryToSection[data.category] ?? 'home';
</script>

<GameCategoryLobby {gameCategory}>
	<SeoText section={seoSection} noContainer />
</GameCategoryLobby>
